import { all, call, takeLatest, put, select } from 'redux-saga/effects'

import { showGenericMessage } from '../app/actions'
import * as actions from './actions'
import * as types from './constants'
import * as services from './services'
import { emailRegex, emailToLowerCase } from '../../utils/validators'
import { signInSuccessful } from '../auth/actions'

export function * changeTemporaryPasswordSaga ({ payload }) {
  const { data } = payload
  try {
    const { lang, user } = yield select(state => state.auth)
    const response = yield call(services.changeTemporaryPasswordService, {
      ...data,
      locale: lang,
      token: user.user.token,
      email: user.user.user.email
    })
    yield put(actions.changeTemporaryPasswordSuccess())
    yield put(signInSuccessful(response.data))
  } catch (error) {
    yield put(actions.changeTemporaryPasswordFailure())
  }
}

export function * recoverPassword ({ payload }) {
  const { data, translation } = payload
  const loginLowered = emailToLowerCase(data.login)

  if (emailRegex.test(loginLowered)) {
    try {
      const { lang } = yield select(state => state.auth)
      const recoverData = yield call(services.recoverPassword, {
        login: loginLowered,
        locale: lang
      })

      if (!recoverData.user_phrase) {
        const message = emailRegex.test(loginLowered)
          ? translation('resetPassword')['passwordResetEmailSentSuccessfully']
          : translation('resetPassword')['noSecretQuestion']
        yield put(showGenericMessage(message))
      }

      yield put(actions.recoverPasswordSuccessful({
        userPhrase: recoverData.user_phrase
      }))
    } catch (error) {
      yield put(showGenericMessage(translation('resetPassword')['noFindEmail']))
      yield put(actions.recoverPasswordFailure(error))
    }
  } else {
    yield put(showGenericMessage(translation('resetPassword')['invalidEmailFormat']))
    yield put(actions.recoverPasswordFailure())
  }
}

export function * resetPassword ({ payload }) {
  const { data, translation, token } = payload
  try {
    const { lang } = yield select(state => state.auth)
    const response = yield call(services.resetPassword, { ...data, locale: lang, token: token })
    yield put(showGenericMessage(translation('resetPassword')['resetPasswordSuccess']))
    yield put(actions.resetPasswordSuccessful(response.data))
    if (response.status === 200) {
      window.location.href = '/success_recover_password'
    }
  } catch (error) {
    const errorMessagePath = error.response.data.message
    const errorMessage = 'O link já foi utilizado.'
    if (error.response.status === 422 && errorMessagePath === errorMessage) {
      yield put(showGenericMessage(translation('resetPassword')['alreadyUsedLink']))
      yield put(actions.resetPasswordFailure(error))
    } else {
      yield put(showGenericMessage(translation('resetPassword')['resetPasswordError']))
      yield put(actions.resetPasswordFailure(error))
    }
  }
}

// Watchers
export function * watchRecoverPassword () {
  yield takeLatest(types.RECOVER_PASSWORD, recoverPassword)
}

export function * watchResetPassword () {
  yield takeLatest(types.RESET_PASSWORD, resetPassword)
}

export function * watchChangeTemporaryPasswordSaga () {
  yield takeLatest(types.CHANGE_TEMPORARY_PASSWORD, changeTemporaryPasswordSaga)
}

export default function * sagas () {
  yield all([
    watchRecoverPassword(),
    watchResetPassword(),
    watchChangeTemporaryPasswordSaga()
  ])
}
